<li class="dropdown-nav" [ngClass]="{ container: isLargeScreen }">
  <div
    class="dropdown-nav__content"
    [ngClass]="{ 'dropdown-nav__content--open': isOpen }"
  >
    <div
      class="dropdown-nav__content__label"
      [ngClass]="{
        'dropdown-nav__content__label--active':
          isOpen && !isActiveChild && !isActiveGrandChild,
        'dropdown-nav__content__label-child':
          isActiveChild && !isActiveGrandChild,
        'dropdown-nav__content__label-child--active':
          isOpen && isActiveChild && !isActiveGrandChild,
        'dropdown-nav__content__label-grandchild': isActiveGrandChild,
      }"
      (click)="toggle($event)"
    >
      <a
        class="dropdown-nav__content__label__anchor"
        [ngClass]="{ 'copy-s': isActiveGrandChild }"
        (click)="navigateTo(menuItem.url, $event)"
      >
        {{ menuItem.title }}
      </a>
      <div
        *ngIf="!isActiveGrandChild"
        class="dropdown-nav__content__label__icon"
      >
        <hdi-icon
          [ngClass]="{ flip: isOpen }"
          [iconName]="getDropdownIcon(menuItem)"
          [iconPrefix]="'far'"
          [color]="isOpen && !isActiveChild ? Colors.WHITE : Colors.BLACK"
        ></hdi-icon>
      </div>
    </div>
    <ng-container *ngIf="menuItem.subitems && menuItem.subitems.length > 0">
      <ul
        class="dropdown-nav-child-list"
        [ngClass]="{ 'dropdown-nav-child-list--open': isOpen }"
      >
        <hdi-dropdown-nav
          *ngFor="let subItem of menuItem.subitems"
          [menuItem]="subItem"
          [isActiveChild]="true"
          [isActiveGrandChild]="isActiveChild"
          (click)="closeMenu.emit()"
        ></hdi-dropdown-nav>
      </ul>
    </ng-container>
  </div>
</li>
